import { sectionSvgUploadCtrl } from './section.svg.upload.controller';
import template from './section.svg.upload.html';

export const sectionSvgUpload: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: sectionSvgUploadCtrl,
  controllerAs: 'vm',
  template,
  restrict: 'AE',
  scope: {
    sectionId: '=',
  },
});
